import { IconProps } from '@chakra-ui/react';
import {
  AutotraderIcon,
  BookingsIcon,
  BooksyIcon,
  CalendarIcon,
  CheckaTradeIcon,
  ChefHatIcon,
  FacebookOfficialIcon,
  FreshaIcon,
  GoogleOfficialIcon,
  InstagramIcon,
  LinkedInIcon,
  LinkTreeIcon,
  PinterestIcon,
  TikTokIcon,
  TreatwellIcon,
  TripAdvisorIcon,
  TrustpilotIcon,
  WhatsAppIcon,
  YelpBurstIcon,
  YouTubeIcon,
} from '../ui';
import { FC } from 'react';

export const locationLinksList = [
  'google',
  'facebook',
  'yelp',
  'trustpilot',
  'tripadvisor',
  'tiktok',
  'youtube',
  'instagram',
  'whatsapp',
  'linkedin',
  'pinterest',
  'fresha',
  'booksy',
  'linktree',
  'checkatrade',
  'treatwell',
  'autotrader',
  'menu',
  'appointment',
  'bookings',
];

export type TContactPlatform = (typeof locationLinksList)[number];

export const reviewsLocationLinks: TContactPlatform[] = [
  'google',
  'facebook',
  'yelp',
  'tripadvisor',
  'trustpilot',
  'autotrader',
  'fresha',
  'booksy',
];

export const socialMediaLocationLinks: TContactPlatform[] = [
  'instagram',
  'tiktok',
  'youtube',
  'whatsapp',
  'linkedin',
  'pinterest',
  'linktree',
  'checkatrade',
  'treatwell',
];

export const customLocationLinks: TContactPlatform[] = ['menu', 'bookings', 'appointment'];

interface ILocationLinkMeta {
  name: string;
  Icon: FC<IconProps>;
}

export const locationLinksMeta: Record<TContactPlatform, ILocationLinkMeta> = {
  google: {
    name: 'Google',
    Icon: GoogleOfficialIcon,
  },
  facebook: {
    name: 'Facebook',
    Icon: FacebookOfficialIcon,
  },
  yelp: {
    name: 'Yelp',
    Icon: YelpBurstIcon,
  },
  trustpilot: {
    name: 'TrustPilot',
    Icon: TrustpilotIcon,
  },
  tripadvisor: {
    name: 'TripAdvisor',
    Icon: TripAdvisorIcon,
  },
  tiktok: {
    name: 'TikTok',
    Icon: TikTokIcon,
  },
  youtube: {
    name: 'YouTube',
    Icon: YouTubeIcon,
  },
  instagram: {
    name: 'Instagram',
    Icon: InstagramIcon,
  },
  whatsapp: {
    name: 'WhatsApp',
    Icon: WhatsAppIcon,
  },
  linkedin: {
    name: 'LinkedIn',
    Icon: LinkedInIcon,
  },
  pinterest: {
    name: 'Pinterest',
    Icon: PinterestIcon,
  },
  fresha: {
    name: 'Fresha',
    Icon: FreshaIcon,
  },
  booksy: {
    name: 'Booksy',
    Icon: BooksyIcon,
  },
  linktree: {
    name: 'LinkTree',
    Icon: LinkTreeIcon,
  },
  checkatrade: {
    name: 'CheckaTrade',
    Icon: CheckaTradeIcon,
  },
  treatwell: {
    name: 'TreatWell',
    Icon: TreatwellIcon,
  },
  autotrader: {
    name: 'AutoTrader',
    Icon: AutotraderIcon,
  },
  menu: {
    name: 'Menu',
    Icon: (props: IconProps) => ChefHatIcon({ ...props, color: 'orange' }),
  },
  appointment: {
    name: 'Appointment',
    Icon: (props: IconProps) => CalendarIcon({ ...props, color: 'green' }),
  },
  bookings: {
    name: 'Bookings',
    Icon: (props: IconProps) => BookingsIcon({ ...props, color: 'primary.pure' }),
  },
};
